import { api2 } from './api'

export const getTaxpayerByDocument = async ({ type, docNumber }) => {
  try {
    const response = await api2.get(`TaxPayer?type=${type}&document=${docNumber}`)
    if (!response.data.data || response.data.data.consultaContribuyente === null) {
      throw new Error('No se encontraron resultados para el documento ingresado')
    }
    return response.data.data.consultaContribuyente
  } catch (error) {
    console.log(error)
    return ''
    // throw new Error(error.message)
  }
}
